import { c as _c } from "react/compiler-runtime";
import { createContext, type Dispatch, type PropsWithChildren, useContext, useReducer } from 'react';
import { initialNavigatorState, type NavigatorState } from './context';
import { navigatorReducer } from './reducers/navigatorReducer';
type NavigatorContextType = {
  state: NavigatorState;
  dispatch: Dispatch<any>;
};
const NavigatorContext = createContext<NavigatorContextType>({
  state: initialNavigatorState,
  dispatch: () => {}
});
export const useNavigatorContext = () => {
  return useContext(NavigatorContext);
};
export const NavigatorContextProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [state, dispatch] = useReducer(navigatorReducer, initialNavigatorState);
  let t1;
  if ($[0] !== state) {
    t1 = {
      state,
      dispatch
    };
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <NavigatorContext.Provider value={t1}>{children}</NavigatorContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};